import {
  doc,
  collection,
  query,
  orderBy,
  getDocs,
  onSnapshot
} from 'firebase/firestore';
import { db } from '../firebase';

/**
 * 모든 슬라이드 오타 검사 결과 조회
 * @param {string} docId - 문서 ID
 * @returns {Promise<Object>} 모든 슬라이드 오타 결과
 */
export const fetchAllSlideTypoResults = async (docId) => {
  try {
    const slidesRef = collection(db, 'PPT_FILE', docId, 'typo_results');
    const q = query(slidesRef, orderBy('slide_index'));
    const querySnapshot = await getDocs(q);

    const slides = [];
    querySnapshot.forEach((doc) => {
      // 문서 ID가 숫자 형태가 아니면 건너뛰기 (total_results, gemini_metadata 등 특수 문서)
      if (!/^\d+$/.test(doc.id)) {
        return;
      }

      const data = doc.data();
      const slideIndex = parseInt(doc.id);

      // typo_results 필드에서 오타 데이터 확인 (백엔드에서 실제로 사용하는 필드)
      const typoResults = data.typo_results || {};
      const hasTypoCheck = typoResults.typos !== undefined;
      const typos = typoResults.typos || null;

      slides.push({
        slide_index: slideIndex,
        text: data.text || '',
        thumbnail_url: data.thumbnail_url || '',
        typos: typos, // null 또는 실제 오타 배열
        has_typos: typos && typos.length > 0,
        has_typo_check: hasTypoCheck, // typos가 undefined가 아니면 검사 완료
        typo_check_data: typoResults, // 전체 typo_results 데이터
        check_error: data.check_error || false, // 검사 실패 플래그
        error_message: data.error_message || '' // 에러 메시지
      });
    });

    return {
      slides,
      total_slides: slides.length
    };
  } catch (error) {
    console.error('모든 슬라이드 오타 결과 조회 오류:', error);
    return { error: error.message };
  }
};

/**
 * 오타 분석 진행상황을 실시간으로 구독하는 함수
 * @param {string} docId - 문서 ID
 * @param {Function} callback - 진행상황 업데이트 콜백
 * @returns {Function} unsubscribe 함수
 */
export const subscribeToTypoAnalysisProgress = (docId, callback) => {
  try {
    const docRef = doc(db, 'PPT_FILE', docId);
    const progressRef = doc(collection(docRef, 'typo_results'), 'analysis_progress');

    const unsubscribe = onSnapshot(progressRef, { includeMetadataChanges: true }, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        callback({
          status: data.status || '',
          percent: data.percent || 0,
          completed: data.completed || false,
          current_slide: data.current_slide || 0,
          total_slides: data.total_slides || 0,
          total_typos: data.total_typos || 0,
          total_cost_krw: data.total_cost_krw || 0,
          successful_slides: data.successful_slides || 0,
          failed_slides: data.failed_slides || 0,
          error: data.error || null
        });
      } else {
        callback({
          status: '',
          percent: 0,
          completed: false,
          error: null
        });
      }
    }, (error) => {
      console.error('오타 분석 진행상황 구독 오류:', error);
      callback({ error: error.message });
    });

    return unsubscribe;
  } catch (error) {
    console.error('오타 분석 진행상황 구독 설정 오류:', error);
    return null;
  }
};
